/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlogEntryImage } from './BlogEntryImage';
import {
    BlogEntryImageFromJSON,
    BlogEntryImageFromJSONTyped,
    BlogEntryImageToJSON,
} from './BlogEntryImage';

/**
 * 
 * @export
 * @interface BlogEntry
 */
export interface BlogEntry {
    /**
     * 
     * @type {string}
     * @memberof BlogEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BlogEntry
     */
    blogId: string;
    /**
     * 
     * @type {string}
     * @memberof BlogEntry
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof BlogEntry
     */
    text: string;
    /**
     * 
     * @type {Date}
     * @memberof BlogEntry
     */
    date: Date;
    /**
     * 
     * @type {Array<BlogEntryImage>}
     * @memberof BlogEntry
     */
    images: Array<BlogEntryImage>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BlogEntry
     */
    twitterStatusIds?: Array<number>;
}

/**
 * Check if a given object implements the BlogEntry interface.
 */
export function instanceOfBlogEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "blogId" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "images" in value;

    return isInstance;
}

export function BlogEntryFromJSON(json: any): BlogEntry {
    return BlogEntryFromJSONTyped(json, false);
}

export function BlogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'blogId': json['blogId'],
        'title': json['title'],
        'text': json['text'],
        'date': (new Date(json['date'])),
        'images': ((json['images'] as Array<any>).map(BlogEntryImageFromJSON)),
        'twitterStatusIds': !exists(json, 'twitterStatusIds') ? undefined : json['twitterStatusIds'],
    };
}

export function BlogEntryToJSON(value?: BlogEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'blogId': value.blogId,
        'title': value.title,
        'text': value.text,
        'date': (value.date.toISOString()),
        'images': ((value.images as Array<any>).map(BlogEntryImageToJSON)),
        'twitterStatusIds': value.twitterStatusIds,
    };
}

